<div class="main-container">
  <app-header *ngIf="!hideHeader" role="banner"></app-header>
  <!-- <app-livechat *ngIf="hideHeader"></app-livechat> -->
  <!-- <div class="tooltip" *ngIf="(logged$ | async) && !isClose">
    <ng-ui-kit-tooltip
      icId="chatbot-tooltip"
      position="bottom"
      color="info"
      [gIcon]="{ name: 'chat_bubble_outline' }"
      triggers="hover">
      {{ 'CHATBOT.DATA-TOOLTIP-MESSAGE' | translate }}
      <button
        class="tooltip-close-btn"
        (click)="isClose = true"
        [aria-label]="'ACCESSIBILITY.CLOSE_TOOLTIP' | translate">
        <i class="material-icons">close</i>
      </button>
    </ng-ui-kit-tooltip>
  </div> -->
  <main
    id="main-content"
    tabindex="-1"
    [ngClass]="{
      hideMargin: currentRoute === '/login' || currentRoute === '/error',
    }"
    class="ic1-container">
    <ng-container *ngIf="!isBlacklistUrl && logged$ | async">
      <app-user-details></app-user-details>
      <div class="app-breadcrumbs" *ngIf="!isHomepage">
        <app-breadcrumbs></app-breadcrumbs>
      </div>
    </ng-container>
    <div
      [ngClass]="{
        hideMargin: currentRoute === '/login' || currentRoute === '/error',
      }"
      class="routing-container">
      <router-outlet> </router-outlet>
    </div>
  </main>
  <app-footer
    *ngIf="!hideFooter"
    role="contentinfo"
    [ngClass]="{ 'ic1-mt-100': currentRoute !== '/login' }"></app-footer>
</div>
